module.exports = __webpack_public_path__ + "static/media/previewNormingLower.4b4cd58e.mp4";